/**
 * Owned Media — preguntas sugeridas de supportIA (burbuja del FAB y chat vacío),
 * en el idioma de la pantalla.
 */
import { useTranslation } from 'react-i18next';

export function useOmlSuggestedQuestions(): string[] {
  const { t } = useTranslation();
  return [
    t('oml.assistant.q1', '¿Qué journeys están activos y en qué cuentas?'),
    t('oml.assistant.q2', '¿Quién es el equipo y el Growth Partner de cada cuenta?'),
    t('oml.assistant.q3', '¿Qué plataforma usa cada cliente?'),
  ];
}
